import { axiosV1 } from 'interceptors/axios';
import { Dispatch } from 'redux';

import { decryptResponse } from 'utils/token';
import { dispatchError } from 'utils/dispatchError';

type GetHoldingClassesProps = {
  holdingClassId: string;
  partnerId?: string;
  signal?: AbortSignal;
};

export const getHoldingClassById =
  ({ holdingClassId, partnerId, signal }: GetHoldingClassesProps) =>
  async (dispatch: Dispatch) => {
    try {
      const url = `/holdingClasses/${holdingClassId}${
        partnerId ? `?partnerId=${partnerId}` : ''
      }`;

      const { data } = await axiosV1.get(url);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
